import PageLang from "./page-lang";
import DetectMobileBrowsers from "./detect-mobile-browsers";

class Popup {
  constructor(
    html,
    element = null,
    autoShowPopup = false,
    iKSORISNotice = false
  ) {
    this.popupModal = $("#popup-modal");
    this.popupModalContent = $("#popup-modal-content");
    this.dataIksorisNotice = this.popupModalContent.attr("data-iksoris-notice");

    this.html = html;
    this.element = element;
    this.autoShowPopup = autoShowPopup;
    this.iKSORISNotice = iKSORISNotice;
    this.translates = {
      _eb2bede64f61af542f7c5d37f17ba201: {
        pl: "Zamknij",
        en: "Close"
      },
      tak: {
        pl: "Tak",
        en: "Yes"
      },
      nie: {
        pl: "Nie",
        en: "No"
      },
      zapisz: {
        pl: "Zapisz",
        en: "Save"
      }
    };
    this.onClose = function() {};
    this.onConfirm = null;
    this.onSave = null;
    this._isOpenPopup = false;
    this.init();
  }

  get isOpenPopup() {
    return this._isOpenPopup;
  }

  set isOpenPopup(value) {
    this._isOpenPopup = value;
  }

  events() {
    if (typeof this.html !== "string" && typeof this.html !== "object") {
      throw "To nie jest kod HTML!";
    }

    const _this = this;

    if (this.element) {
      $(document).on("click", this.element, function(event) {
        event.preventDefault();
        _this.isOpenPopup = _this.popupModal.hasClass("show");

        if (_this.isOpenPopup) {
          _this.popupModal.modal("hide");
        } else {
          _this.showPopup();
        }
      });
    }

    this.popupModal.on("hidden.bs.modal", function(event) {
      _this.removeHTML();
      _this.onClose();

      if (_this.isOpenPopup) {
        _this.showPopup();
        _this.isOpenPopup = false;
      }
    });

    if (this.autoShowPopup) {
      if (this.dataIksorisNotice !== "" && this.iKSORISNotice) {
        this.showIKSORISNoticePopup();
      } else if (this.dataIksorisNotice === "" && !this.iKSORISNotice) {
        this.showPopup();
      }
    }

    //Zdarzenia zdefiniowane po pokazaniu się popupa:
    this.popupModal.off("shown.bs.modal").on("shown.bs.modal", function() {
      //dodaj przyciski "tak" lub "nie" jeśli jest wymagane jakieś potwierdzenie

      if (typeof _this.onConfirm === "function") {
        _this.popupModalContent.append(_this.confirmHtml());
      } else if (typeof _this.onSave === "function") {
        _this.popupModalContent.append(_this.saveHtml());
      }

      $(".js-shopping-cart-alert-remove-confirm").on("click", function(e) {
        e.preventDefault();
        if (_this.onConfirm && typeof _this.onConfirm === "function") {
          _this.popupModal.modal("hide");
          setTimeout(function() {
            _this.onConfirm();
          }, 500);
        }
      });

      $(document).on("click", ".save-btn", function(e) {
        e.preventDefault();
        if (_this.onSave && typeof _this.onSave === "function") {
          setTimeout(function() {
            _this.onSave();
            _this.popupModal.modal("hide");
          }, 500);
        }
      });
    });
  }

  confirmHtml() {
    let przyciski;

    if ($("body").hasClass("mobile")) {
      przyciski =
        '<div class="form__section form__section--last">\n' +
        '                <div class="form__btns">\n' +
        '                  <a href="#" class="form__btn js-shopping-cart-alert-remove-confirm">' +
        this.translates.tak[PageLang.get()] +
        "</a>\n" +
        '                  <a href="#" class="form__btn form__btn--white js-shopping-cart-alert-remove-false" data-dismiss="modal">' +
        this.translates.nie[PageLang.get()] +
        "</a>\n" +
        "                </div>\n" +
        "              </div>";
    } else {
      przyciski =
        '<div class="form__section form__section--last">' +
        '<div class="form__btns">' +
        '<a href="#" class="form__btn--half-popup btn btn--large btn--brown js-shopping-cart-alert-remove-confirm">' +
        this.translates.tak[PageLang.get()] +
        "</a>" +
        '<a href="#" class="form__btn--half-popup btn btn--large btn--white js-shopping-cart-alert-remove-false" data-dismiss="modal">' +
        this.translates.nie[PageLang.get()] +
        "</a>" +
        "</div>" +
        "</div>";
    }

    return przyciski;
  }

  saveHtml() {
    const isMobileBrowser = DetectMobileBrowsers.check();

    if (isMobileBrowser) {
      return `<div class="form__section form__section--last">
                <div class="form__btns">
                  <a href="#" class="form__btn save-btn">${
                    this.translates.zapisz[PageLang.get()]
                  }</a>
                </div>
              </div>`;
    } else {
      return `<div class="form__section form__section--last">
                <div class="form__btns">
                  <a href="#" class="btn btn--large btn--brown save-btn">${
                    this.translates.zapisz[PageLang.get()]
                  }</a>
                </div>
              </div>`;
    }
  }

  showPopup() {
    this.addHTML();
    this.popupModal.modal("show");
  }

  showIKSORISNoticePopup() {
    this.addIKSORISNoticePopupHTML();
    this.popupModal.modal("show");
  }

  hidePopup() {
    this.removeHTML();
    this.popupModal.modal("hide");
  }

  addHTML() {
    this.popupModalContent.append(this.html);
  }

  addIKSORISNoticePopupHTML() {
    const isMobileBrowser = DetectMobileBrowsers.check();
    let IKSORISNoticePopupHTML = ``;

    if (isMobileBrowser) {
      IKSORISNoticePopupHTML = `<p class="fr-popup__text">${
        this.dataIksorisNotice
      }</p>
                                <div class="form__section form__section--last">
                                  <div class="form__btns">
                                    <a href="#" class="form__btn" data-dismiss="modal">${
                                      this.translates
                                        ._eb2bede64f61af542f7c5d37f17ba201[
                                        PageLang.get()
                                      ]
                                    }</a>
                                  </div>
                                </div>`;
    } else {
      IKSORISNoticePopupHTML = `<p class="fr-popup__text">${
        this.dataIksorisNotice
      }</p>
                                <div class="form__section form__section--last">
                                  <div class="form__btns">
                                    <a href="#" class="form__btn--half-popup btn btn--large btn--brown" data-dismiss="modal">${
                                      this.translates
                                        ._eb2bede64f61af542f7c5d37f17ba201[
                                        PageLang.get()
                                      ]
                                    }</a>
                                  </div>
                                </div>`;
    }

    this.popupModalContent.append(IKSORISNoticePopupHTML);
  }

  removeHTML() {
    this.popupModalContent.html("");
  }

  init() {
    try {
      this.events();
    } catch (e) {
      console.error(e);
    }
  }
}

export default Popup;
